export default "__VITE_ASSET__DqwsAy3o__"